import { render } from "./MainLogo.vue?vue&type=template&id=4540ee8e&scoped=true"
const script = {}

import "./MainLogo.vue?vue&type=style&index=0&id=4540ee8e&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4540ee8e"]])

export default __exports__